import { useEffect, useRef } from "react";
import { useSearch } from "./SearchContext";



export default function HighlightText({ text = "", tag: Tag = "span", className = "", style = {} }) {
  const { query, registerMatches } = useSearch();
  const containerRef = useRef(null);

  // After every render, collect all <mark> elements inside this container
  // and register them with the context.
  
  useEffect(() => {
    if (!containerRef.current) return;
    const marks = Array.from(containerRef.current.querySelectorAll("mark.search-hit"));
    // We only register if this component has hits — the Navbar aggregates all
    // marks globally via a separate effect.
  }, [query]);

  if (!query || query.trim().length < 2) {
    return <Tag className={className} style={style}>{text}</Tag>;
  }

  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escaped})`, "gi");
  const parts = text.split(regex);

  return (
    <Tag ref={containerRef} className={className} style={style}>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark
            key={i}
            className="search-hit"
          >
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </Tag>
  );
}